export default __webpack_public_path__ + "fonts/SourceSansPro-LightIt.eot";